<template>

    <el-form class="login-form" :model="loginForm" :rules="loginRule" ref="loginForm" label-position="left" size="mini">
        <h3 class="title">登录</h3>
<!--        <el-form-item prop="role" label="角色：">-->
<!--            <el-select v-model="loginForm.role" placeholder="请选择">-->
<!--                <el-option-->
<!--                        v-for="item in options"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                </el-option>-->
<!--            </el-select>-->
<!--        </el-form-item>-->

        <el-form-item prop="username">
            <el-input type="text" v-model="loginForm.userId" auto-complete="on" placeholder="账户"/>
        </el-form-item>
        <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" auto-complete="on" placeholder="密码"/>
        </el-form-item>
        <!-- <el-checkbox class="remember" v-model="checked">记住密码</el-checkbox> -->
        <el-button type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin"
                   :loading="logining">登录
        </el-button>
    </el-form>

</template>

<script>
    function checkUsername(rule, value, cb) {
        cb()
    }

    function checkPassword(rule, value, cb) {
        if (value.length < 3) {
            cb(new Error('The password can not be less than 6 digits'))
        } else {
            cb()
        }
    }

    function handleLogin() {
        this.$refs.loginForm.validate((valid) => {
            // console.log("handle login",valid);
            if (!valid) {
                // console.log("login bad data!");
                return false;
            }
            this.logining = true;
            const params = {userId: this.loginForm.userId, password: this.loginForm.password, role:-1};

            this.$axios.post('/auth/login', params).then(res => {
                this.logining = false;
                let user = res.user;

                //this.apps格式 ["www|企业"]
                if(user.role === 2){
                    this.apps = [
                        "后台管理|后台管理"
                    ]
                } else  if(user.role === 4){
                  this.apps = [
                    "客服|客服"
                  ]
                }else {
                    //出了role为2剩下的都是企业用户登录，要么业务员，要么企业后台管理员
                    if(user.qiyeId == "" || user.qiyeName == ""){
                        this.$message.error(`该帐号无效，请联系后台管理员确认所属企业`);
                        return
                    }

                    if(user.role === 0){
                        this.apps = [
                            `${user.qiyeName}|业务员`
                        ]
                    } else {
                        this.apps = [
                            `${user.qiyeName}|企业`
                        ]
                    }
                }

                user.apps = this.apps;

                //jwt
                user.jwt = res.jwt;

                this.$store.commit("login", user)

                this.$router.replace('/home')
            }).catch(res => {
                this.logining = false;
            })
        })
    }

    export default {
        data() {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    role:0,
                },
                //0普通业务员，1管理员, 2后台管理人
                options:[
                    {value:0, label:"业务员"},
                    {value:1, label:"企业管理员"},
                    {value:2, label:"后台管理员"},
                ],
                loginRule: {
                    username: [{require: true, trigger: 'blur', validator: checkUsername}],
                    password: [{require: true, trigger: 'blur', validator: checkPassword}]
                },
                checked: true,
                logining: false
            }
        },
        methods: {
            handleLogin: handleLogin
        }
    }
</script>

<style scoped>

    .login-form {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
    }

    .remember {
        float: left;
        margin: 0px 0px 35px 0px;
    }

</style>
